import React, { useEffect } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AccountInfoType, ConfirmationType, UserType } from 'shared/types';
import ResponseList from './screens/list';
import ResponseView from './screens/view';

function Response({
  accountInfo,
  userInfo,
  setConfirmationData,
}: {
  accountInfo?: AccountInfoType;
  userInfo?: UserType;
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
}) {
  const { path } = useRouteMatch();
  useEffect(() => {
    return () => {
      window.localStorage.removeItem('response:filter');
      window.localStorage.removeItem('response:filterViewId');
    };
  }, []);
  return (
    <Switch>
      <Route exact path={`${path}/:id/:responseId`}>
        <ResponseView accountInfo={accountInfo} userInfo={userInfo} />
      </Route>
      <Route exact path={`${path}/:id`}>
        <ResponseList
          setConfirmationData={setConfirmationData}
          accountInfo={accountInfo}
          userInfo={userInfo}
        />
      </Route>
      <Route path={path}>
        <ResponseList
          setConfirmationData={setConfirmationData}
          accountInfo={accountInfo}
          userInfo={userInfo}
        />
      </Route>
    </Switch>
  );
}

export default Response;
